"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _CodeInput = _interopRequireDefault(require("../../../components/Input/CodeInput"));

var _Text = require("../Text");

var _classnames = _interopRequireDefault(require("classnames"));

var STATUS = {
  error: -1,
  normal: 0,
  loading: 1,
  loaded: 2
};

function AuthenticationInputCodeStep(_ref, ref) {
  var onVerify = _ref.onVerify,
      onNext = _ref.onNext,
      _ref$login = _ref.login,
      login = _ref$login === void 0 ? false : _ref$login;

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = (0, _react.useState)(STATUS.normal),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      status = _useState4[0],
      setStatus = _useState4[1];

  var handleOnChange = function handleOnChange(next) {
    setValue(next.replace(/[^0-9]/gi, ''));
  };

  (0, _react.useImperativeHandle)(ref, function () {
    return {
      next: function next() {
        if (value.trim().length < 6) {
          setStatus(STATUS.error);
          return Promise.reject('empty code');
        }

        return onVerify(value).then(function (res) {
          setStatus(STATUS.loaded);
          return res;
        })["catch"](function (e) {
          setStatus(STATUS.error);
          throw e;
        });
      }
    };
  }, [value]);
  return /*#__PURE__*/_react["default"].createElement("div", null, login ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-3xl font-semibold text-gray-dark"
  }, "Enter the code generated by your authentication app"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-sm text-secondary"
  }, "We'll ask for a verification code any time we notice a login from a device or browser we don't recognize.")) : /*#__PURE__*/_react["default"].createElement(_Text.PrimaryText, null, "Enter the code generated by your authentication app"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-6"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('text-gray-light uppercase font-bold', {
      'text-sm': login
    })
  }, "CODE"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-5"
  }, /*#__PURE__*/_react["default"].createElement(_CodeInput["default"], {
    id: "code",
    autoFocus: true,
    standalone: true,
    value: value,
    onChange: handleOnChange,
    onKeyDown: function onKeyDown(e) {
      e.key === 'Enter' && onNext();
    }
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-red text-sm font-semibold mt-2"
  }, status === STATUS.error && 'Invalid code'));
}

var _default = /*#__PURE__*/(0, _react.forwardRef)(AuthenticationInputCodeStep);

exports["default"] = _default;
//# sourceMappingURL=TOTPInputCode.js.map